import { ClassAttributes, InputHTMLAttributes } from "react"
import styles from "./Input.module.css";

export const Input = (props: JSX.IntrinsicAttributes & ClassAttributes<HTMLInputElement> & InputHTMLAttributes<HTMLInputElement>) => {
    return <input className={styles.input} {...props} />
}